function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import shared, { paddingBlockStartEnd, paddingInlineStartEnd } from "./shared";
import { white, blue30 } from '../../../../eden-style-constants';
import hexToRgba from "hex2rgba";
import styled from "styled-components";
const Component = styled.button.withConfig({
  componentId: "sc-11cmx9o-0"
})(["", ";padding:calc(", " - 1px) calc(", " - 1px);", ";", ";&:hover{background:none;", ";}&:active{", ";}"], shared, paddingBlockStartEnd, paddingInlineStartEnd, ({
  inverted
}) => inverted ? `background: linear-gradient(
    150deg,
    rgba(255, 255, 255, 0.3),
    rgba(255, 255, 255, 0)
  )` : `background: linear-gradient(
    150deg,
    rgba(255, 255, 255, 0) 75%,
    ${hexToRgba(blue30, 0.13)}
  )`, ({
  theme,
  inverted
}) => theme.primaryColor ? `color: ${theme.primaryColor};
         border: 1px solid ${theme.primaryColor};
        ` : inverted ? `color: ${white};
         border: 1px solid ${white};
        ` : `color: ${blue30};
         border: 1px solid ${blue30};
        `, ({
  theme,
  inverted
}) => theme.primaryColor ? `color: ${theme.primaryColor}` : inverted ? `color: ${white}` : `color: ${blue30}`, ({
  inverted
}) => inverted ? `background: linear-gradient(
        150deg,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0.3)
      )` : `background: linear-gradient(
        150deg,
        ${hexToRgba(blue30, 0.13)},
        rgba(255, 255, 255, 0) 25%
      )`);
/**
 * On components with multiple buttons this should be the default style used. This button style indicates that an action is a viable path to choose when completing a task. This style is subservient to the Primary button style.
 */

const Secondary = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
  ref: ref,
  as: props.disabled ? "button" : props.href ? "a" : "button"
}), props.children));
Secondary.defaultProps = {
  type: "button"
};
Secondary.displayName = "Secondary";
Secondary.propTypes = {
  /** The button contents */
  children: PropTypes.node.isRequired,

  /** Whether to apply styles that help the button stand out on a dark background */
  inverted: PropTypes.bool,

  /** Whether to apply smaller styles */
  small: PropTypes.bool,

  /** Theme style values */
  theme: PropTypes.shape({
    primaryColor: PropTypes.string
  }),

  /** The [type of the button](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Attributes), if an href is present it will be the [type of the link](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#Attributes) */
  type: PropTypes.string,

  /** If the button should expand to the full width of its parent */
  fullWidth: PropTypes.bool,

  /** If the button should be disabled */
  disabled: PropTypes.bool,

  /** The link that the button should navigate to on click */
  href: PropTypes.string
};
export default Secondary;